export class GraphAxis {
  public static data: any = [
    { type: "Bar", axis: ["X", "Y"] },
    { type: "Pie", axis: ["X", "Y"] },
    { type: "Word cloud", axis: ["X"] },
    { type: "Tree Map", axis: ["X"] },
    { type: "Stacked bar", axis: ["X", "Y"] },
    { type: "Gauge", axis: ["X"] },
    { type: "Doughnut", axis: ["X", "Y"] },
    { type: "Heat map", axis: ["X", "Y", "Shade", "Size"] },
    { type: "Bubble chart", axis: ["X", "Y", "Shade", "Size"] },
    { type: "Line chart", axis: ["X", "Y"] },
    { type: "Semi Doughnut", axis: ["X"] },
    { type: "Spider chart", axis: ["X", "Y"] },
    { type: "Combination chart", axis: ["X", "Y", "Shade", "Size"] },
    { type: "Dual Axis", axis: ["X", "Y", "Shade", "Size"] },
    { type: "Scatter plot", axis: ["X", "Y", "Shade", "Size"] },
    { type: "Multi Line chart", axis: ["X", "Y"] },
    { type: "Pivot", axis: ["X", "Y", "Shade", "Size"] },
    { type: "Basic column", axis: ["X", "Y"] }
  ];

  public static UserDataKeywords: any = [
    { type: "Industry", keyword: "industryId", name: "industries", format: true, labels: ['industryName'], sst:"industry" },
    { type: "IT Budget", keyword: "itBudgetId", name: "itBudgets", format: true, labels: ['itBudgetFrom', 'itBudgetTo'], sst:"it_budget" },
    { type: "Geography", keyword: "geographyId", name: "geographies", format: true, labels: ['geographicTitle'], sst:"geography" },
    { type: "Line of Business", keyword: "lineOfBusinessId", name: "lineOfBusinesses", format: true, labels: ['lineOfBusiness'], sst:"line_of_business" },
    { type: "Country", keyword: "countryId", name: "countries", format: true, labels: ['countryName'], sst:"country" },
    { type: "Employee Size", keyword: "employeeSizeId", name: "employeeSizes", format: true, labels: ['employeeSizeFrom', 'employeeSizeTo'], sst:"employee_size" },
    { type: "Job Title", keyword: "jobTitleId", name: "jobTitles", format: true, labels: ['jobTitle'], sst:"job_title" },
    { type: "Global Revenue", keyword: "globalRevenueId", name: "revenues", format: true, labels: ['revenueFrom', 'revenueTo'], sst:"revenue" }
  ];
}



// WEBPACK FOOTER //
// ./src/app/shared/constants/graphAxis.ts